import { useTelemetry } from './useTelemetry'

type WorkflowEntity = 'feature' | 'project' | 'test_run' | 'test_case' | 'bug'

type WorkflowProperties = Record<string, string | number | boolean | null | undefined>

const compactProperties = (properties: WorkflowProperties = {}) =>
  Object.entries(properties).reduce<Record<string, string | number | boolean>>((acc, [key, value]) => {
    if (value === null || value === undefined || value === '') return acc
    return {
      ...acc,
      [key]: value,
    }
  }, {})

export const trackCreateFlowCompleted = (entity: WorkflowEntity, properties: WorkflowProperties = {}) => {
  useTelemetry().track('create_flow_completed', {
    workflow_entity: entity,
    ...compactProperties(properties),
  })
}

export const trackCreateFlowFailed = (entity: WorkflowEntity, properties: WorkflowProperties = {}) => {
  useTelemetry().track('create_flow_failed', {
    workflow_entity: entity,
    ...compactProperties(properties),
  })
}

export const trackExportFlowCompleted = (entity: WorkflowEntity, properties: WorkflowProperties = {}) => {
  useTelemetry().track('export_flow_completed', {
    workflow_entity: entity,
    ...compactProperties(properties),
  })
}

export const trackExportFlowFailed = (entity: WorkflowEntity, properties: WorkflowProperties = {}) => {
  useTelemetry().track('export_flow_failed', {
    workflow_entity: entity,
    ...compactProperties(properties),
  })
}
